import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

interface CustomDialogModel {
  title: string,
  description: string,
  primaryLabel: string,
  secondaryLabel: string,
}

@Component({
  selector: 'app-custom-dialog',
  templateUrl: './custom-dialog.component.html',
  styleUrl: './custom-dialog.component.scss'
})


export class CustomDialogComponent {


  constructor(
    public dialogRef: MatDialogRef<CustomDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CustomDialogModel) {}

  close(param: boolean) {
    this.dialogRef.close(param);
  }
}
